export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9337.e8323722.jpg";